import { createContext } from 'react';

import { ResidentSettingsState } from 'features/residents/resident-settings/providers/states/resident-settings-state';

const ResidentSettingsProviderContext = createContext({} as ResidentSettingsState);

export default ResidentSettingsProviderContext;
